import React from "react";

function ContainerIn(props) {
  return (
    <div
      className="containerIn"
    >
      {props.children}
    </div>
  );
}

export default ContainerIn;
